import type { OrderProductResponse, PaymentResponse } from '@/core/generated/api';
import { paymentResponseToSummary } from '../mappers';
import { FormDetails } from '@/shared/ui/FormDetails/FormDetails';
import type { KeyValueDataObject } from '@/shared/ui/KeyValueRow/KeyValueRow';
import { Link } from '@/shared/ui/Link/Link';
import { PaymentPositionsTable } from './PaymentPositionsTable';

interface PaymentDetailsProps {
    payment: PaymentResponse;
    orderProducts: OrderProductResponse[];
}

/** Показывает реквизиты и позиции платежа в карточке заказа */
export const PaymentDetails = ({ payment, orderProducts }: PaymentDetailsProps) => {
    const summary = paymentResponseToSummary(payment);

    const details: KeyValueDataObject[] = [
        {
            label: 'Внешний идентификатор',
            value: summary.externalId,
        },
        {
            label: 'Сумма платежа',
            value: summary.amount,
        },
        {
            label: 'Сумма платежа со скидкой',
            value: summary.amountWithDiscount,
        },
        {
            label: 'Скидка',
            value: summary.discount,
        },
        {
            label: 'Статус платежа',
            value: summary.status,
        },
        ...(summary.paymentUrl
            ? [{
                label: 'Ссылка на оплату',
                value: <Link
                    url={summary.paymentUrl}
                    isBlank
                    text="Оплатить на Robokassa"
                    showCopyButton
                />,
            }]
            : []),
    ];

    return (
        <div>
            <h2>Платеж</h2>
            <FormDetails dataForShow={details} />
            <h3>Позиции платежа</h3>
            <PaymentPositionsTable
                positions={payment.paymentPositions ?? []}
                orderProducts={orderProducts}
            />
        </div>
    );
};
